import LaunchIcon from '@mui/icons-material/Launch';
import { IconButton, Stack, Typography } from '@mui/material';
import React, { memo, useMemo, useRef, useState } from 'react';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import CustomFieldModal from '../../../../modals/tables/dashboards/rows/CustomFieldModal';
import useStyles from "../styles";

const CustomFieldCell: React.FC<{
    dashboard: Dashboard,
    fieldName: string,
 }> = ({ dashboard, fieldName }) => {
    const classes = useStyles();
    const [customFieldModalOpen, setCustomFieldModalOpen] = useState<boolean>(false);
    const [fieldHover, setFieldHover] = useState<boolean>(false);
    const latestUpdateRef = useRef<HTMLElement>(null);

    const customFieldValues = useMemo(() =>
        dashboard?.customFields?.find(({ name }) => name === fieldName)?.value as string
    , [dashboard, fieldName]);

    return (<>
        {(!!customFieldValues && !['N/A', 'None'].includes(customFieldValues)) ? (
            <Stack direction="row" alignItems="center" justifyContent="space-between"
                width="100%" ref={latestUpdateRef}
                onMouseLeave={() => setFieldHover(false)}
                onMouseEnter={() => setFieldHover(true)}>
                <Typography className={classes.url} sx={{ maxWidth: '20ch !important' }}>
                    {customFieldValues}
                </Typography>
                {fieldHover && (
                    <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                        <IconButton disableRipple
                            onClick={() => setCustomFieldModalOpen(true)}
                            sx={{ padding: 'unset !important'}}>
                            <LaunchIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                        </IconButton>
                    </Stack>
                )}
            </Stack>
        ) : (
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                <Typography className={classes.plainText} fontWeight={500} color={`${theme.colors.neutral['500']} !important` }>
                    {'No values'}
                </Typography>
            </Stack>
        )}
        {customFieldModalOpen && (
            <CustomFieldModal open={customFieldModalOpen}
                dashboard={dashboard}
                fieldName={fieldName}
                anchorElement={latestUpdateRef.current}
                onClose={() => setCustomFieldModalOpen(false)} />
        )}
    </>);
}

export default memo(CustomFieldCell);
